import { lazy } from "react";
import { BsTicket } from "react-icons/bs";
import { FaChartBar, FaCoins, FaUsers } from "react-icons/fa";
import { FaRegFileLines } from "react-icons/fa6";
import { FiUser, FiUsers } from "react-icons/fi";
import { IoListSharp, IoSpeedometerOutline } from "react-icons/io5";
import {
  MdOutlineCategory,
  MdOutlineContactSupport,
  MdOutlineDashboardCustomize,
  MdOutlineFlag,
  MdOutlineInvertColors,
  MdOutlinePhotoSizeSelectActual,
} from "react-icons/md";
import { RiShapesFill, RiUserSettingsLine } from "react-icons/ri";
import { CgStyle } from "react-icons/cg";

const AddRole = lazy(() => import("../pages/AddRole"));
const SupportManagement = lazy(() => import("../pages/SupportManagement"));
const EditRole = lazy(() => import("../pages/EditRole"));
const Login = lazy(() => import("../pages/Login"));
const PromotionVouchers = lazy(() => import("../pages/PromotionVouchers"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const AddEditCampaign = lazy(() => import("../pages/AddEditCampaign"));
const AddEditVoucher = lazy(() => import("../pages/AddEditVoucher"));
const ProductManagement = lazy(() => import("../pages/ProductManagement"));
const ProductDetails = lazy(() => import("../pages/ProductDetails"));
const AddProduct = lazy(() => import("../pages/AddProduct"));
const EditProduct = lazy(() => import("../pages/EditProduct"));
const OrderDetails = lazy(() => import("../pages/OrderDetails"));
const OrderManagement = lazy(() => import("../pages/OrderManagement"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Notifications = lazy(() => import("../pages/Notifications"));
const AccountSettings = lazy(() => import("../pages/Account Settings"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const RoleManagement = lazy(() => import("../pages/RoleManagement"));
const StaffManagement = lazy(() => import("../pages/StaffManagement"));
const UserManagementDetail = lazy(() => import("../pages/UserDetail"));
const AnalyticsReport = lazy(() => import("../pages/Analytics&Report"));
const Cms = lazy(() => import("../pages/Cms"));
const AddEditBanner = lazy(() => import("../pages/AddEditBanner"));
const Shapes = lazy(() => import("../pages/Shapes"));
const Colours = lazy(() => import("../pages/Colours"));
const Coins = lazy(() => import("../pages/CoinManagement"));
const Categories = lazy(() => import("../pages/Categories"));
const Lengths = lazy(() => import("../pages/LengthManagement"));
const Styles = lazy(() => import("../pages/StylesManagement"));
const Countries = lazy(() => import("../pages/Countries"));

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <IoSpeedometerOutline />,
    element: <Dashboard />,
  },

  {
    path: "/orders/:id",
    exact: true,
    protected: true,
    element: <OrderDetails />,
  },
  {
    path: "/account-settings",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AccountSettings />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <FiUsers />,
    element: <UserManagement />,
  },
  {
    path: "/orders",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Order Management",
    icon: <IoListSharp />,
    element: <OrderManagement />,
  },
  {
    path: "/products",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Product Management",
    icon: <MdOutlineDashboardCustomize />,
    element: <ProductManagement />,
  },
  {
    path: "/add-product",
    exact: true,
    protected: true,
    element: <AddProduct />,
  },
  {
    path: "/edit-product/:id",
    exact: true,
    protected: true,
    element: <EditProduct />,
  },
  {
    path: "/products/:id",
    exact: true,
    protected: true,
    element: <ProductDetails />,
  },
  {
    path: "/analytics-report",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Analytics & Report",
    icon: <FaChartBar />,
    element: <AnalyticsReport />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <UserManagementDetail />,
  },
  {
    path: "/promotion-vouchers",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Promotion & Vouchers",
    icon: <BsTicket />,
    element: <PromotionVouchers />,
  },
  {
    path: "/add-edit-campaign",
    exact: true,
    protected: true,
    element: <AddEditCampaign />,
  },
  {
    path: "/add-edit-voucher",
    exact: true,
    protected: true,
    element: <AddEditVoucher />,
  },
  {
    path: "/role-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Role Management",
    icon: <RiUserSettingsLine />,
    element: <RoleManagement />,
  },
  {
    path: "/add-role",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Add Role",
    icon: <FaUsers />,
    element: <AddRole />,
  },
  {
    path: "/edit-role/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Edit Role",
    icon: <FaUsers />,
    element: <EditRole />,
  },
  {
    path: "/staff-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Staff Management",
    icon: <FiUsers />,
    element: <StaffManagement />,
  },
  {
    path: "/support-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Support Management",
    icon: <MdOutlineContactSupport />,
    element: <SupportManagement />,
  },
  {
    path: "/notifications",
    title: "Notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    icon: <IoSpeedometerOutline />,
    element: <Notifications />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <FaRegFileLines />,
    element: <Cms />,
  },
  {
    path: "/settings",
    title: "Profile Settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <FiUser />,
    element: <ProfileSettings />,
  },
  {
    path: "/add-edit-banner",
    title: "Banners Detail",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditBanner />,
  },
  {
    path: "/shapes",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Shapes Management",
    icon: <RiShapesFill />,
    element: <Shapes />,
  },
  // {
  //   path: "/colours",
  //   exact: true,
  //   protected: true,
  //   showInSidebar: true,
  //   title: "Colors Management",
  //   icon: <MdOutlineInvertColors />,
  //   element: <Colours />,
  // },
  {
    path: "/coins",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Coins Management",
    icon: <FaCoins />,
    element: <Coins />,
  },
  {
    path: "/categories",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Categories Management",
    icon: <MdOutlineCategory />,
    element: <Categories />,
  },
  {
    path: "/lengths",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Lengths Management",
    icon: <MdOutlinePhotoSizeSelectActual />,
    element: <Lengths />,
  },
  {
    path: "/styles",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Styles Management",
    icon: <CgStyle />,
    element: <Styles />,
  },
  {
    path: "/countries",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Countries Management",
    icon: <MdOutlineFlag />,
    element: <Countries />,
  },
];
